import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page. WordPress sent it to /hair-restoration-research/,
// which holds the same text (3 Nov 2026).
export const Route = createFileRoute("/hair-cloning-follicle-banking")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/hair-restoration-research/", location.searchStr), statusCode: 301 });
  },
});
